<template>
  <div class="sendBox-tips">
    <h3>什么是变速沙箱？</h3>
    <ul>
      变速沙箱是App内置的模拟安卓环境的容器，可在该空间内运行游戏。相比安装游戏到本地，优势在于：
      <br /><br />
      <li>
        1、免安装，免密安装，更绿色安全，完美解决了OPPO、ViVO等设备安装本地需要密码的问题;
      </li>
      <li>
        2、支持双开;
      </li>
      <li>
        3、变速沙箱内提供工具：游戏变速，按键录制，连点器，断网启动等;
      </li>
      <li>4、单机和网游均支持导入沙箱，体验变速功能</li>
    </ul>

    <h3>为什么仅支持64位游戏？</h3>
    <p>
      因市面大部分游戏都是64位，目前沙箱仅支持64位的游戏，个别32位游戏将无法使用，请等待后续更新。
    </p>

    <h3>什么是游戏变速？</h3>
    <p>
      变速沙箱启动游戏后，可打开悬浮球体验变速功能，最高变速10倍。可帮助加速游戏进度，如快速获取资源等
    </p>

    <h3>变速沙箱问题：</h3>
    <p>
      <span style="color: red;">
        部分游戏不支持加速等功能，可能会影响游戏规则，继续使用玩家将自行承担后果，如无法加速请不要继续使用，以免造成角色封禁等问题；
      </span>
      <br />
      部分游戏安装沙箱失败，无法安装成功。该情况多为设备、游戏与沙箱的兼容性问题，出现此情况时，可尝试将游戏安装至本地，如仍有问题，可联系在线客服反馈。我们将不断优化沙箱兼容性。
    </p>
    <h3>游戏运行问题：</h3>
    <p>
      部分游戏安装沙箱后无法启动，或启动后出现闪退/卡死等问题，该情况多为设备、游戏与沙箱的兼容性问题，此时您可尝试退出后再次沙箱重新启动游戏。如仍有问题，可尝试游戏安装至本地。
      变速沙箱的每次迭代更新，均经过严格测试，考量多种终端设备与游戏兼容性，您的使用也将鼓励我们不断优化迭代。
    </p>
  </div>
</template>
<style scoped>
.sendBox-tips {
  padding: 32px;
  background-color: #f7f8fa;
  height: 100vh;
  overflow: auto;
}
.sendBox-tips h3 {
  margin: 20px 0 20px;
  font-size: 32px;
  color: #333;
}
ul {
  color: #333;
}
.sendBox-tips p,
li {
  font-size: 28px;
  color: #999;
}
</style>
